<template>
  <!-- 选择技能/模式/牌位，弹窗 -->
  <div>
    <div class="section">
      <div class="title">
        技能
      </div>
      <div class="check-wrap">
        <div
          v-for="skill in skillList"
          :key="skill.id || skill.key"
          :class="{
            'check': true,
            'blank': !skill.id,
            'checked': skill.id === skillId
          }"
          @click="changeSkill(skill)"
        >{{ skill.name }}</div>
      </div>
    </div>
    
    <div class="section" v-show="modeList.length">
      <div class="title">
        模式
      </div>
      <div class="check-wrap">
        <div
          v-for="mode in modeList"
          :key="mode.id"
          :class="{
            'check': true,
            'blank': !mode.id,
            'checked': mode.id === selectedMode.id
          }"
          @click="changeMode(mode)"
        >{{ mode.name }}</div>
      </div>
    </div>

    <div class="section" v-show="levelList.length">
      <div class="title">
        {{ isWinMode ? '您的牌位' : '牌位' }}
      </div>
      <div class="check-wrap">
        <div
          v-for="(level, index) in levelList"
          :key="level || index"
          :class="{
            'check': true,
            'blank': !level,
            'checked': selectedLevel.includes(level)
          }"
          @click="changeLevel(level)"
        >{{ level }}</div>
      </div>
    </div>

    <div class="section" v-show="selectedSkill.id === 38">
      <div class="title">時間</div>
      <el-time-picker
        class="custom-time-picker"
        v-model="clockTime"
        value-format="HH:mm"
        :picker-options="{
          format: 'HH:mm'
        }"
        :editable="false"
        :clearable="false"
        placeholder="任意时间点">
      </el-time-picker>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    isOpen: {
      type: Boolean,
      default: false
    },
    initSkillList: Array,
    initSkill: Object,
    initMode: Object,
    initLevel: Array,
  },
  data() {
    const isProd = process.env.VUE_APP_ENV === 'production'
    const promiseWinFiter = [
      {
        skill: 1,
        mode: isProd ? [29, 30] : [31, 32],
      },
      {
        skill: 6,
        mode: isProd ? [31] : [33],
      },
    ]
    return {
      selectedSkill: {},
      selectedMode: {},
      selectedLevel: [],
      clockTime: new Date().$format('hh:mm'),
      promiseWinFiter,
    }
  },
  computed: {
    skillId() {
      return this.selectedSkill.id
    },

    skillList() {
      return this.concatAry(this.initSkillList)
    },

    modeList() {
      return this.concatAry(this.selectedSkill.gameModelList)
    },

    levelList() {
      return this.concatAry(this.selectedSkill.quickMatchLevel)
    },
    isWinMode() {
      const skill = this.selectedSkill;
      const mode = this.selectedMode;
      if(this.selectedLevel) {
        this.setLevel([this.selectedLevel[0]])
      }
      let aaa = this.promiseWinFiter.some(item => {
        return skill.id === item.skill && item.mode.includes(mode.id);
      });
      return aaa
    }
  },
  watch: {
    isOpen(open) {
      if (open) {
        this.init()
      }
    }
  },
  created() {
    this.init()
  },
  methods: {
    setLevel(level) {
      this.selectedLevel = level
    },
    init() {
      if (this.initSkill) {
        this.selectedSkill = this.initSkill
        this.selectedMode = this.initMode
        this.selectedLevel = this.initLevel
      }
    },
    changeSkill(skill) {
      if (!skill.id) return
      this.selectedSkill = skill
      this.$nextTick(() => {
        if (this.modeList.length) {
          this.selectedMode = this.modeList[0]
        } else {
          this.selectedMode = {}
        }
        if (skill.quickMatchLevel && skill.quickMatchLevel.length) {
          this.selectedLevel = ['不限']
        } else {
          this.selectedLevel = []
        }
      })
    },
    changeMode(mode) {
      if (!mode.id) return
      this.selectedMode = mode
    },
    changeLevel(level) {
      if (!level) return
      if (level === '不限') {
        this.selectedLevel = ['不限']
      } else {
        if(this.isWinMode) {
          return this.selectedLevel = [level]
        }
        const val = this.selectedLevel
        const index = this.selectedLevel.indexOf(level)
        if (val.length === 1 && val[0] === level) return
        if (val.length === 1 && val[0] === '不限') {
          return this.selectedLevel = [level]
        }
        if (index > -1) {
          this.selectedLevel.splice(index, 1)
        } else {
          this.selectedLevel.push(level)
        }
      }
    },
    concatAry(list) {
      if (!list || !list.length) {
        return []
      }
      let len = list.length % 3
      len = len ? 3 - len : 0
      for (let i = 0; i < len; i++) {
        list.push(typeof list[0] == 'string' ? '' : {
          key: `unique_${ i }`
        })
      }
      return list
    }
  }
}
</script>

<style lang="scss" scoped>
  .section {
    margin-top: 30px;
    .title {
      color: #333;
      font-weight: 500;
      font-size: 16px;
      line-height: 18px;
      padding-bottom: 7px;
    }
  }
  .custom-time-picker {
    margin-top: 9px;
    /deep/ .el-input__inner {
      background: #F1F3F6;
      border: 0;
      cursor: pointer;
      // border: 1px solid #999;
    }
  }
  .check-wrap {
    display: flex;
    flex-wrap: wrap;
    .check {
      @include ellipsis(1);
      flex-shrink: 0;
      flex-grow: 1;
      width: 25%;
      height: 44px;
      border-radius: 8px;
      padding: 15px;
      margin: 9px 0 0 9px;
      background: #F1F3F6;
      color: #323D4F;
      font-size: 14px;
      line-height: 14px;
      text-align: center;
      cursor: pointer;
      &.checked {
        background: #FCEEF4;
        color: #FA006E;
      }
      &.blank {
        background: none;
        cursor: default;
      }
      &:nth-child(3n + 1) {
        margin-left: 0;
      }
    }
  }
</style>